<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PLAN PROIZVODNJE PO LINIJAMA</h2>

  <div class="content-block calendar-wrapper">
    <div class="filter-wrapper">
      <div class="selectDate">
        <dx-date-box
          [value]="todayDate"
          pickerType="calendar"
          width="300"
          format="month"
          maxZoomLevel="year"
          displayFormat="month"
          (onValueChanged)="onValueChanged($event)"
        >
        </dx-date-box>
      </div>
      <div class="selectLine">
        <span>Odabir linije</span>
        <dx-select-box
          [disabled]="false"
          [items]="linije"
          [value]="linije[0].id"
          valueExpr="id"
          displayExpr="naziv"
          [width]="300"
          (onValueChanged)="promjenaLinije($event)"
        >
        </dx-select-box>
      </div>
      <div class="colorInfo">
        <span>SMJENA DODJELJENA <span class="shift-yes"></span></span>
        <span>SMJENA NIJE DODJELJENA <span class="shift-no"></span></span>
      </div>
    </div>
    <ul *ngIf="planDohvacen" class="week-grid">
      <li *ngFor="let day of monthArr">
        <div class="week-header">
          <span class="day-name">{{ day.dan }}</span>
          <span class="day-date">{{ day.datum }}</span>
        </div>
        <div class="smjene">
          <span (click)="otvoriPopup(day.datum, 1)">SMJENA 1</span>
          <span (click)="otvoriPopup(day.datum, 2)">SMJENA 2</span>
          <span (click)="otvoriPopup(day.datum, 3)">SMJENA 3</span>
        </div>
      </li>
    </ul>
    <p *ngIf="!planDohvacen">Učitavanje...</p>
  </div>

  <dx-popup
    [width]="1000"
    [height]="'auto'"
    [showTitle]="true"
    title="Pregled proizvodnje smjena {{ smjena }} datum {{ datum }}"
    [dragEnabled]="true"
    [closeOnOutsideClick]="true"
    [(visible)]="popupVisible"
    [position]="{ my: 'top', at: 'top', offset: '0 114' }"
  >
    <div>
      <div style="position: absolute; right: 70px; top: 20px">
        <dx-button
          text="Print"
          icon="pdffile"
          hint="PDF"
          (onClick)="createPdf()"
        >
        </dx-button>
      </div>
      <div class="dx-field">
        <ul class="smjena-podaci">
          <li>
            <span>Šifra</span>
            <span>Naziv proizvoda</span>
            <span>Planirana količina</span>
            <span>Kartona</span>
            <span>Paleta</span>
            <span>Naziv linije</span>
            <span>Plan</span>
          </li>
          <li *ngFor="let data of smjenaPodaci">
            <span>{{ data.sifra }}</span>
            <span>{{ data.proizvod }}</span>
            <span>{{ data.kolicina }}</span>
            <span>{{ data.kartoni }}</span>
            <span>{{ data.palete }}</span>
            <span>{{ data.linija }}</span>
            <span>{{ data.idPlan }}</span>
          </li>
        </ul>
      </div>
    </div>
  </dx-popup>
</div>
